export default "__VITE_ASSET__CWo3V5tu__"